import i18n from '../i18n';
import { useNotificationStore } from '../store/notificationStore';

/**
 * What a Sync now ended in, said where the user sees it. The corner popup
 * toasts are switched off app-wide (ui/Toast.js POPUP_TOASTS_ENABLED), so
 * toastT alone showed nothing — "saved here, goes out when back online" and
 * "Sync failed" never reached the user (found in the Sandbox run, 03.10.2026).
 * Title-bar notifications, user-started syncs only (the offline queue retries
 * quietly; its state is on the row).
 */
export function notifyGit(kind, workspace, detail = '') {
  const store = useNotificationStore.getState();
  if (kind === 'info') {
    store.info(i18n.t('toast.gitQueuedOffline', { name: workspace.name }), i18n.t('toast.gitWaitingTitle'));
  } else {
    store.error(i18n.t('toast.gitSyncFailed', { name: workspace.name, message: detail }).trim(), i18n.t('toast.gitSyncFailedTitle'));
  }
}
